import SystemRouteList from "./SystemRouteList";

export default {
  list: SystemRouteList,
};
